import { postApiGalaxyServer } from 'services';

export interface EnableDirectDatabaseIntegrationPayload {
  teamId: string;
}

export const enableDirectDatabaseIntegrationApi = ({
  params,
  token,
  config,
}: BaseApiParams<EnableDirectDatabaseIntegrationPayload>) => {
  return postApiGalaxyServer(`/realm/enableDirectDatabaseIntegration`, params, config ?? {}, token);
};
